export default "skymp5-front/cff89a05e712e3292c20d3cb2d51a233.png";